import { useEffect, useState } from "react";

const Header = () => {
  const [sticky, setSticky] = useState(false);

  const handleScroll = () => {
    const isShortPage = document.documentElement.scrollHeight <= 1700;
    if (isShortPage)
      setSticky(true);
    else if (!isShortPage && window.scrollY > 50)
      setSticky(true)
    else if (!isShortPage && window.top)
      setSticky(false);
  };

  useEffect(() => {
    const checkIfShortPage = () => {
      console.log(document.documentElement.scrollHeight, window.innerHeight * 1.3);
      const isShort = document.documentElement.scrollHeight <= 1700;  //880 × 1.3 = 1144px  (880px hauteur laptop)

      if (isShort) {
        setSticky(true);
      }
    };

    const onLoadOrResize = () => {
      requestAnimationFrame(checkIfShortPage);
    };

    if (document.readyState === "complete") {
      onLoadOrResize();
    } else {
      window.addEventListener("load", onLoadOrResize);
    }

    window.addEventListener("resize", onLoadOrResize);
    window.addEventListener("scroll", handleScroll);

    // Nettoyage
    return () => {
      window.removeEventListener("load", onLoadOrResize);
      window.removeEventListener("resize", onLoadOrResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTeam = () => {
    window.scrollTo({
      top: 700,
      behavior: "smooth",
    });
  };

  return (
    <header
      className={`fixed top-0 z-50 w-full transition-all duration-500 ease-in-out before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-0 before:bg-primary before:transition-all before:duration-500 before:ease-in-out ${
        sticky ? "before:h-full" : "before:h-0"
      }`}
    >
      <div className="container">
        <nav
          className={`relative flex flex-row item-center ${
            sticky ? "py-1" : "py-7"
          }`}
        >
          <div className="flex w-[80px] sm:w-[160px] justify-start items-center">
            <a href="/">
              <img
                className="h-[60px] w-[60px] sm:h-[100px] sm:w-[100px]"
                src={ sticky ? "/images/logo/logo2.png" : "/images/logo/logo-navbar.png"}
                alt="logo45"
              />
            </a>
          </div>
          <div className="sm:w-[80px] md:w-[160px]" />
          <div
            className={`flex w-full justify-between items-center content-center ${
              sticky ? "text-[#ad3500]" : "text-white"
            } font-[Jost] font-[500] uppercase tracking-[2px] text-[7px] sm:text-[10px] md:text-[15px] underline`}
          >
            <div>
              <a href="/home"> Accueil </a>
            </div>
            <div>
              <a href="/about"> À propos </a>
            </div>
            <div>
              <a onClick={scrollToTeam}> Équipe </a>
            </div>
            <div>
              <a href="/contact"> Contact </a>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
